import React from 'react';
import TOUnknownErrorView from './Views/TO/UnknownErrorView';
import pushAnalytics from './../analytics/pushAnalytics';

const COMPONENT_TREE = [{ component_name: 'UnknownError', component_version: '1.0.0' }];

class UnknownError extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
    pushAnalytics('aa-pageload', {
      app: 'tcom sign in',
      page_name: 'Service Down',
      content_section: 'Sign In',
      displayed_error_message: 'SERVICE DOWN',
      metrics: 'km-page-error'
    }, COMPONENT_TREE);
  }

  render() {
    return (
      /* FIXME: OnSubmit, the info is showing up in the URL */
      <div>
        <TOUnknownErrorView />
      </div>
    );
  }
}

export default UnknownError;